import { render, staticRenderFns } from "./TeachEdit.vue?vue&type=template&id=2bd4cae0&"
import script from "./TeachEdit.vue?vue&type=script&lang=js&"
export * from "./TeachEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeachEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports